import { render, staticRenderFns } from "./article_guide_table.vue?vue&type=template&id=400e4c49&scoped=true"
import script from "./article_guide_table.vue?vue&type=script&lang=ts"
export * from "./article_guide_table.vue?vue&type=script&lang=ts"
import style0 from "./article_guide_table.vue?vue&type=style&index=0&id=400e4c49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400e4c49",
  null
  
)

export default component.exports